import { ActionReducerMap } from '@ngrx/store';
import { procedurePrescriptionsFeatureKey, proceduresFeatureKey, ProceduresState } from '../../entities';
import * as fromProcedurePrescription from './procedure-prescription.reducer';
import * as fromProcedure from './procedure.reducer';

export const proceduresReducerMap: ActionReducerMap<ProceduresState> = {
    [proceduresFeatureKey]: fromProcedure.reducer,
    [procedurePrescriptionsFeatureKey]: fromProcedurePrescription.reducer,
};
